import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-anounce",
  "use": "icon-anounce-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"icon-anounce\"><path fill=\"#e20036\" d=\"M13.334 4.717V7.29l-4.18-.138 2.388 3.445L9.2 11.974l-2.113-3.72-2.113 3.72-2.343-1.378L5.02 7.151.84 7.29V4.717l4.18.138L2.63 1.41 4.974.032l2.113 3.72L9.2.032l2.342 1.378-2.388 3.445z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol